import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { LinkBlock } from "./LinkBlock";
import { defaultData } from "./LinkBlockDefaultData";
import { meta } from "./LinkBlockMetaData";

export const LinkBlockExport: BlockExport = {
  type: "component",
  Block: LinkBlock,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-link",
    size: 24,
  },
  defaultData,
  meta,
};
